/* eslint-disable no-empty */


export default class {
    constructor($el) {
        this.$ = $el;
        this.sections = [];
        $el.find('.-section').each((i, el)=>{
            this.sections.push(new AccordionSection($(el), this));
        });
        if (this.sections.length) {
            this.sections[0].expand();
        }
    }
}


class AccordionSection {
    constructor($el, master) {
        this.$ = $el;
        this.master = master;
        this.$head = $el.find('.-head');
        this.$content = $el.find('.-content');
        this.$height = this.$content.find('.-height');
        this.isExpanded = false;
        this.$head.click(()=>{
            this.isExpanded = ! this.isExpanded;
            if (this.isExpanded) {
                this.expand();
            } else {
                this.close();
            }
            return false;
        });
    }

    expand() {
        this.isExpanded = true;
        this.$.addClass('-expanded');
        let height = this.$height.outerHeight();
        this.$content.css('height', height + 'px');
        setTimeout(()=>{
            this.$content.css('height', 'auto');
        }, 800);
    }

    close() {
        this.isExpanded = false;
        this.$.removeClass('-expanded');
        let height = this.$height.outerHeight();
        this.$content.css('height', height + 'px');
        setTimeout(()=>{
            this.$content.css('height', 0);
        }, 10);
    }
}




// WEBPACK FOOTER //
// ./scripts/lib/Accordion.js